'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducers = require('./reducers');

Object.defineProperty(exports, 'configs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducers).default;
  }
});

var _selectors = require('./selectors');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_selectors).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-config-provider/dist/main/index.js
// module id = 511
// module chunks = 0